/* 布局 */
//前台
import Layout from "@views/layout";

const propertyspecRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "propertyspec/list",
        name: "PROPERTYSPEC",
        meta: {
            title: "资产规格管理",
            keepAlive:true
        },
        component: () => import("@views/business/propertyspec/index.vue"),
    },
        ],
};

export default propertyspecRouter;
